/* eslint-disable @typescript-eslint/no-explicit-any */
import { ICrud } from "./common";
import { IVoucher } from "./Voucher";

export enum EDiscountType {
  PERCENT = "PERCENT",
  PRICE = "PRICE",
}

export enum EPromotionStatus {
  ACTIVE = "ACTIVE",
  DEACTIVE = "DEACTIVE",
}

export enum EPromotionType {
  PACKAGE = "PACKAGE",
}

export enum EUsageLimitType {
  PER_USER = "PER_USER",
  PER_PROMO_CODE = "PER_PROMO_CODE",
}

export interface IPromotion extends ICrud {
  code: string;
  description?: string;
  discount?: number;
  discountType?: EDiscountType;
  status: EPromotionStatus;
  startDate?: Date;
  endDate?: Date;
  type?: EPromotionType;
  //numberOfVoucher?: number | null;
  usageLimitType: EUsageLimitType;
  usageLimit: number;
  vouchers: IVoucher[];
}

export interface ICreatePromotionDTO {
  code: string;
  description?: string;
  discount?: number;
  discountType?: EDiscountType;
  status?: EPromotionStatus;
  startDate?: Date;
  endDate?: Date;
  //numberOfVoucher?: number | null;
  usageLimitType: EUsageLimitType;
  usageLimit: number;
  type?: EPromotionType;
}

export interface IPromotionDTO {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  code: string;
  description: string;
  discount: string;
  discountType: string;
  status: string;
  startDate: string;
  endDate: string;
  type: string;
  usageLimitType: string;
  usageLimit: EUsageLimitType;
}

